(function () {
  function setError(message) {
    var el = document.getElementById('CartDrawer-CartErrors');
    if (el) el.textContent = message || '';
  }

  function parseCartResponse(response) {
    return response.json().then(function (data) {
      if (!response.ok || data.status >= 400 || data.errors) {
        var err = new Error(data.description || data.message || data.errors || 'Cart update failed');
        err.data = data;
        throw err;
      }
      return data;
    });
  }

  function replaceFromSection(doc, selector) {
    var target = document.querySelector(selector);
    var source = doc.querySelector(selector);
    if (target && source) target.replaceWith(source);
  }

  function syncUpsell(doc, itemCount) {
    var current = document.getElementById('rb-yml');
    if (itemCount === 0) {
      if (current) current.remove();
      return;
    }
    if (!current) {
      var source = doc.getElementById('rb-yml');
      var anchor = document.querySelector('cart-drawer-items');
      if (source && anchor) anchor.insertAdjacentElement('afterend', source);
    }
  }

  function restoreBreakup(wasOpen) {
    if (!wasOpen) return;
    var breakup = document.getElementById('rb-breakup');
    var toggle = document.getElementById('rb-total-toggle');
    if (breakup) breakup.hidden = false;
    if (toggle) toggle.classList.add('is-open');
  }

  function syncDrawer(state) {
    var html = state && state.sections && state.sections['cart-drawer'];
    if (!html) return;

    var wasBreakupOpen = false;
    var oldBreakup = document.getElementById('rb-breakup');
    if (oldBreakup) wasBreakupOpen = !oldBreakup.hidden;

    var doc = new DOMParser().parseFromString(html, 'text/html');
    replaceFromSection(doc, '.rb-cd__title');
    replaceFromSection(doc, '#CartDrawer-CartItems');
    replaceFromSection(doc, '.rb-cd__summary');
    restoreBreakup(wasBreakupOpen);

    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      drawer.classList.add('animate', 'active');
      if (typeof state.item_count === 'number') drawer.classList.toggle('is-empty', state.item_count === 0);
    }

    syncUpsell(doc, state.item_count);

    setError('');
  }

  function requestCart(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(parseCartResponse);
  }

  function setRowBusy(row, busy, removing) {
    if (!row) return;
    row.classList.toggle('is-updating', busy && !removing);
    row.classList.toggle('is-removing', busy && removing);
    row.querySelectorAll('button').forEach(function (button) { button.disabled = busy; });
  }

  function changeLine(button, quantity) {
    var line = Number(button.dataset.line || 0);
    if (!line) return;

    var row = button.closest('.rb-item');
    var value = row ? row.querySelector('.rb-qty__val') : null;
    var previousValue = value ? value.textContent : '';
    var removing = quantity < 1;

    setRowBusy(row, true, removing);
    requestCart('/cart/change.js', {
      line: line,
      quantity: Math.max(0, quantity),
      sections: ['cart-drawer'],
      sections_url: window.location.pathname
    }).then(syncDrawer).catch(function (error) {
      if (value) value.textContent = previousValue;
      setRowBusy(row, false, false);
      setError((error && error.message) || 'Could not update cart.');
    });
  }

  function removeUpsellCard(card) {
    if (!card) return;
    card.classList.add('is-added');
    setTimeout(function () {
      var list = card.closest('.rb-yml__list');
      var wrap = card.closest('.rb-yml');
      card.remove();
      if (list && !list.querySelector('.rb-yml__card') && wrap) wrap.remove();
    }, 180);
  }

  function addUpsell(button) {
    var id = Number(button.dataset.vid || 0);
    if (!id) return;

    var card = button.closest('.rb-yml__card');
    var oldText = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding...';

    requestCart('/cart/add.js', {
      items: [{ id: id, quantity: 1 }],
      sections: ['cart-drawer'],
      sections_url: window.location.pathname
    }).then(function (state) {
      syncDrawer(state);
      removeUpsellCard(card);
    }).catch(function (error) {
      button.disabled = false;
      button.textContent = oldText;
      setError((error && error.message) || 'Could not add product.');
    });
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('#rb-total-toggle');
    if (toggle) {
      var breakup = document.getElementById('rb-breakup');
      if (breakup) {
        breakup.hidden = !breakup.hidden;
        toggle.classList.toggle('is-open', !breakup.hidden);
      }
      return;
    }

    var qtyButton = event.target.closest('.rb-qty__btn, .rb-item__remove');
    if (qtyButton) {
      event.preventDefault();
      if (qtyButton.disabled) return;

      var row = qtyButton.closest('.rb-item');
      if (row && row.classList.contains('is-updating')) return;

      var value = row ? row.querySelector('.rb-qty__val') : null;
      var current = value ? (parseInt(value.textContent, 10) || 1) : 1;
      var action = qtyButton.dataset.act;
      var next = action === 'plus' ? current + 1 : current - 1;
      if (action === 'remove') next = 0;
      if (next > 0 && value) value.textContent = next;
      changeLine(qtyButton, next);
      return;
    }

    var upsellButton = event.target.closest('.rb-yml__add');
    if (upsellButton) {
      event.preventDefault();
      if (!upsellButton.disabled) addUpsell(upsellButton);
    }
  });
})();